import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { BiometryLogFilter } from '../models/filters/biometrylog-filter';
import { Paging } from '../models/page';
import { BiometryAuthCreditRequest } from '../models/request/biometry-auth-credit-request';
import { BiometryFingerPrintActiveRequest } from '../models/request/biometry-finger-print-active-request';
import { BiometryValidationRequest } from '../models/request/biometry-validation-request';
import { BiometryFingerPrintCaptureRequest } from '../models/request/BiometryFingerPrintCaptureRequest';
import { ResponseModel } from '../models/response-model';
import { ActiveFingerPrintResponse } from '../models/response/ActiveFingerPrintResponse';
import { BiometryValidationResponse } from '../models/response/biometry-validation-response';
import { BiometryLog } from '../models/response/biometrylogResponse';
import { CaptureFingerPrintResponse } from '../models/response/CaptureFingerPrintResponse';
import { CaptureFingerPrintSecuGenResponse } from '../models/response/CaptureFingerPrintSecuGenResponse';

@Injectable({
  providedIn: 'root'
})
export class BiometryService {
  private url = `${environment.url}/biometry`;
  private codeSecurity = "Lu9S%u637t&5";
  private readonly authUrl = `${environment.url}/updateAuthCredit`;

  constructor(private http: HttpClient) { }

  validateBiometry(request: BiometryValidationRequest, sendExternal: boolean = true): Observable<ResponseModel<BiometryValidationResponse>> {
    let params = new HttpParams().append("sendExternal", String(sendExternal));

    return this.http.post<ResponseModel<BiometryValidationResponse>>(this.url, request, { params });
  }

  activeFingerprint(): Observable<ActiveFingerPrintResponse> {
    let url = `${environment.fingerPrintDeviceUrl}/FingerPrint/activeFingerPrint`;

    return this.http.post<ActiveFingerPrintResponse>(url, new BiometryFingerPrintActiveRequest(this.codeSecurity));
  }

  captureFingerprint(device: string): Observable<CaptureFingerPrintResponse> {
    let url = `${environment.fingerPrintDeviceUrl}/FingerPrint/captureFingerPrint`;

    return this.http.post<CaptureFingerPrintResponse>(url, new BiometryFingerPrintCaptureRequest(this.codeSecurity, device));
  }

  captureFingerprintSecuGen(device: string): Observable<CaptureFingerPrintSecuGenResponse> {
    let url = `${environment.fingerPrintDeviceUrlSecuGen}/SGIFPCapture`;
    let body: string = "Timeout=10000&Quality=50&licstr=&templateFormat=ISO&imageWSQRate=0.75";

    return this.http.post<CaptureFingerPrintSecuGenResponse>(url, body);
  }

  updateBiometryWithSupervInfo(code: string, request: { supervUserApprove: string, supervObservations: string }): Observable<ResponseModel<any>> {
    let params = new HttpParams();

    params = params.set(`code`, code);

    return this.http.put<ResponseModel<any>>(this.url, request, { params });
  }

  getBiometryLog(filter: Filter<BiometryLogFilter>): Observable<ResponseModel<Paging<Array<BiometryLog>>>> {
    let params = new HttpParams();
    params = params
      .set('page', filter.page.toString() || '0')
      .set('pageSize', filter.pageSize.toString() || '20');

    params = filter.value.customerCode ? params.set('customerCode', filter.value.customerCode) : params;
    params = filter.value.creditRequestNumber ? params.set('creditRequestNumber', filter.value.creditRequestNumber) : params;
    params = filter.value.user ? params.set('user', filter.value.user) : params;
    params = filter.value.code ? params.set('code', filter.value.code) : params;

    return this.http.get<ResponseModel<Paging<Array<BiometryLog>>>>(this.url, { params });
  }

  updateAuthorizationCredit(request: BiometryAuthCreditRequest, token?: string): Observable<ResponseModel<boolean>> {
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.put<ResponseModel<boolean>>(this.authUrl, request, { headers });
  }
}
